var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        width: "500"
      },
      model: {
        value: _vm.dialog,
        callback: function callback($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [_vm._v(" Delete SSH key ")]
          ),
          _c("v-card-text", [
            _c("p", [
              _vm._v(
                "Are you certain that you wish to delete the key named “" +
                  _vm._s(_vm.sshKey.name) +
                  "”?"
              )
            ])
          ]),
          _c(
            "v-card-actions",
            {
              staticClass: "justify-content-end"
            },
            [
              _c(
                "gg-btn",
                {
                  staticClass: "mb-0",
                  attrs: {
                    secondary: ""
                  },
                  on: {
                    click: _vm.close
                  }
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "gg-btn",
                {
                  staticClass: "mb-0",
                  attrs: {
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.deleteSshKey
                  }
                },
                [_vm._v(" Delete ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }